/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Tree from 'react-animated-tree'
import UserDetailHeader from '../userDetailHeader'
import * as eventServices from '../../../services/eventService'
import * as stringParser from '../../../util/string.util'
import { BASE_IMAGE_PATH, BASE_IMAGE_PATH_NEW, SOCKET_ROOT as liveSocketEndPoint } from '../../../configs/api';
import { OPERATOR_ID } from '../../../configs/const';
import { showBinary, showCasinoControlLink, casinoList, lotusIndex, showAdminBannerLink, showClubGames, showRebateBonus } from '../../../configs/casinoShowList';
import socketIOClient from "socket.io-client";
import { BRANDLOGOFILENAME } from '../../../configs/authSignupConfig';

let userData = JSON.parse(localStorage.getItem("tokenData"))
let eventData
let socket
class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uid: "",
            passcode: "",
            showRightMenu: false,
            userData: userData,
            userAccData: null,
            openList: [],
            cktGroup: {},
            socGroup: {},
            tenGroup: {},
            eleGroup: {},
            kabGroup: {},
            horGroup: {},
            gHndGroup: {},
            isOfficeChannel: false,
            user_role: ''
        };
    }
    toggleList(type) {
        let list = this.state.openList
        let index = list.indexOf(type)
        if (index === -1) {
            list.push(type)
        } else {
            list.splice(index, 1)
        }
        this.setState({ openList: list })
    }
    onChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value })
    }

    componentDidMount() {
        let accessToken = !!localStorage.getItem("userAuthDetail") ? JSON.parse(localStorage.getItem("userAuthDetail")).token : "";
        let userData = localStorage.getItem("tokenData")
        userData = JSON.parse(userData)
        if (!!userData) {
            this.setState({ user_role: userData.user_role });
        }
        // if (accessToken !== "" && accessToken) {
        //     socket = socketIOClient(liveSocketEndPoint, {
        //         query: 'token=' + accessToken,
        //         transports: ["websocket"]
        //     });
        // }
        // socket.emit('user_room', userData.sub)
        // socket.emit('site_room', userData.sub)
        // socket.on("site_room", async (data) => {
        //     let msg = JSON.parse(data)
        //     if (!!msg.command && (msg.command === "FORCE.LOGOUT")) {
        //         self.onLogout()
        //     }
        // })
        document.addEventListener("visibilitychange", function () {
            if (document.hidden) {
                localStorage.setItem("hideTime", (new Date().getTime()) / 1000)
            } else {
                let then = localStorage.getItem("hideTime")
                if (!!then) {
                    let now = (new Date().getTime()) / 1000
                    if (parseInt(now - then) > (3600 * 4)) {
                        self.onLogout()
                    }
                    localStorage.removeItem("hideTime")
                }
            }
        });

        this.setState({ userData: userData });
        // debugger
        if (!!userData && !!userData.sub) {
            // const currUserData = JSON.parse(localStorage.getItem('userAccData'));
            this.setState({ uid: userData.sub }); //, showClubGames: (currUserData.username === 'office' || currUserData.parents.includes('office'))})
        }
        else {
            // if (!!userData && !userData.sub) {
            // debugger
            this.onLogout()
        }
        if (!!userData.pwdch) {
            if (!window.location.href.includes("setpassword")) {
                this.props.history.push("/setpassword")
            }
        }
        // this.loadEventData();
        let self = this
        // eventData = setInterval(async function eventDataLoad() {
        //     clearInterval(eventData)
        //     self.loadEventData()
        //     eventData = setInterval(eventDataLoad, 15000)
        // }, 60000)
    }

    setUserAccData(userAccData) {
        this.setState({ userAccData: userAccData }, () => {
            if (window.location.pathname === '/banner' && this.state.userAccData.level > 2) {
                this.props.history.push("/dashboard");
            }
        });
    }
    componentWillUnmount() {
        clearInterval(eventData)
        document.removeEventListener('visibilitychange', null)
    }

    async loadEventData() {
        let homeData = await eventServices.getHomeData()
        homeData = this.parseBook(homeData)
        let userEventData = !!homeData ? homeData : []
        let events = []
        let event_dictionary = {}
        !!userEventData && userEventData.length > 0 && Array.prototype.forEach.call(userEventData, (mkt, i) => {
            if (!mkt) {
                return false
            }
            let eventIndex = events.findIndex(x => x.id === mkt.event.id)
            let market = { ...mkt.catalogue, ...mkt.marketCondition }
            market.metadata = mkt.metadata
            market.marketBook = !!market.metadata && !!market.metadata.book ? market.metadata.book : null
            market.marketId = mkt.catalogue.marketId
            if (market.provider !== "BETHUBS") {
                if (!market.marketBook || mkt.status === "CLOSED" || market.marketBook.status === "CLOSED" || market.marketBook.status === "INACTIVE") {
                    return false
                }
            }
            if (eventIndex === -1) {
                let evt = mkt.event
                evt.eventTypeId = mkt.eventType.id
                evt.eventType = mkt.eventType.name
                evt.competitionId = mkt.competition.id
                evt.compititionName = mkt.competition.name
                evt.markets = [market]
                events.push(evt)
                event_dictionary[mkt.event.id] = evt
            } else {
                events[eventIndex].markets.push(market)
            }

        })
        if (!!this.props.getEventMarketDictionary) {
            this.props.getEventMarketDictionary(event_dictionary)
        }
        let cricketEvents = events.filter((e) => {
            return e.eventTypeId === "4"
        })
        let cktGroup = cricketEvents.reduce((r, a) => {
            r[a.competitionId] = [...r[a.competitionId] || [], a];
            return r;
        }, {});

        let socEvents = events.filter((e) => {
            return e.eventTypeId === "1"
        })
        let socGroup = socEvents.reduce((r, a) => {
            r[a.competitionId] = [...r[a.competitionId] || [], a];
            return r;
        }, {});

        let tenEvents = events.filter((e) => {
            return e.eventTypeId === "2"
        })
        let tenGroup = tenEvents.reduce((r, a) => {
            r[a.competitionId] = [...r[a.competitionId] || [], a];
            return r;
        }, {});

        let eleEvents = events.filter((e) => {
            return e.eventTypeId === "500"
        })
        let eleGroup = eleEvents.reduce((r, a) => {
            r[a.competitionId] = [...r[a.competitionId] || [], a];
            return r;
        }, {});

        let kabEvents = events.filter((e) => {
            return e.eventTypeId === "400"
        })
        let kabGroup = kabEvents.reduce((r, a) => {
            r[a.competitionId] = [...r[a.competitionId] || [], a];
            return r;
        }, {});

        let horEvents = events.filter((e) => {
            return e.eventTypeId === "7"
        })
        let horGroup = horEvents.reduce((r, a) => {
            r[a.competitionId] = [...r[a.competitionId] || [], a];
            return r;
        }, {});

        let gHndEvents = events.filter((e) => {
            return e.eventTypeId === "4339"
        })
        let gHndGroup = gHndEvents.reduce((r, a) => {
            r[a.competitionId] = [...r[a.competitionId] || [], a];
            return r;
        }, {});

        this.setState({ cktGroup: cktGroup, socGroup: socGroup, tenGroup: tenGroup, eleGroup: eleGroup, kabGroup: kabGroup, horGroup: horGroup, gHndGroup: gHndGroup })
    }
    parseBook(data) {
        !!data && data.length > 0 && Array.prototype.forEach.call(data, (mkt, i) => {
            let book = !!mkt.metadata && !!mkt.metadata.book ? stringParser.deSrlz(mkt.metadata.book) : {}
            // let book = !!mkt.metadata && !!mkt.metadata.book ? JSON.parse(mkt.metadata.book) : {}
            data[i].metadata = {}
            data[i].metadata.book = book
        })
        return data
    }
    openNav() {
        if (document.getElementById("mySidebar").style.display === "block") {
            document.getElementById("mySidebar").style.display = "none";
        } else {
            document.getElementById("mySidebar").style.display = "block";
        }
    }
    home1Submenu() {
        if (document.getElementById("home1Submenu").style.display === "block") {
            document.getElementById("home1Submenu").style.display = "none";
        } else {
            document.getElementById("home1Submenu").style.display = "block";
        }
    }
    home2Submenu() {
        if (document.getElementById("home2Submenu").style.display === "block") {
            document.getElementById("home2Submenu").style.display = "none";
        } else {
            document.getElementById("home2Submenu").style.display = "block";
        }
    }
    home3Submenu() {
        if (document.getElementById("home3Submenu").style.display === "block") {
            document.getElementById("home3Submenu").style.display = "none";
        } else {
            document.getElementById("home3Submenu").style.display = "block";
        }
    }
    home4Submenu() {
        if (document.getElementById("home4Submenu").style.display === "block") {
            document.getElementById("home4Submenu").style.display = "none";
        } else {
            document.getElementById("home4Submenu").style.display = "block";
        }
    }
    homeSubmenu(nm) {
        if (document.getElementById(`home${nm}Submenu`).style.display === "block") {
            document.getElementById(`home${nm}Submenu`).style.display = "none";
        } else {
            document.getElementById(`home${nm}Submenu`).style.display = "block";
        }
    }
    onLogout() {
        localStorage.clear();
        this.props.history.push("/auth")
    }
    toggleCompetition(e) {
        let elem = e.target.parentNode.parentNode.firstChild
        this.eventFire(elem, "click")
    }
    eventFire(el, etype) {
        if (el.fireEvent) {
            el.fireEvent('on' + etype);
        } else {
            var evObj = document.createEvent('Events');
            evObj.initEvent(etype, true, false);
            el.dispatchEvent(evObj);
        }
    }
    setShowClubGames() {
        const currUserData = JSON.parse(localStorage.getItem('userAccData'));
        if (!!currUserData) {
            // this.setState({ isOfficeChannel: (currUserData.username === 'office' || currUserData.parents.includes('office')) })
        }
    }
    render() {
        return (<>
            <header>

                <div className="container-fluid">
                    {/* <span className="tag-live" style={{left:"0px", top:"0px", width:"100%", zIndex:"1", position: "fixed"}}>DEV</span> */}
                    <div className="row">
                        <div className="col-8 col-sm-7 col-md-7 col-lg-2">
                            <div className="navbar-logo" logo-theme="theme1">
                                <i className="fa fa-bars icon-toggle-right mr-1" onClick={(e) => { this.openNav(e) }}></i>
                                <h3 className="mb-0">
                                    <a className="text-white font-weight-bold admin-logo" onClick={() => { this.props.history.push("/dashboard") }} style={{ cursor: "pointer" }}><img alt="" src={`${BASE_IMAGE_PATH}/aimg/${BRANDLOGOFILENAME}`} /></a>
                                </h3>
                            </div>
                        </div>
                        <div className="col-7 col-sm-7 col-md-7 col-lg-8 mobile-hide-menu">
                            <nav id="menu" className='text-center'>
                                <label htmlFor="tm" id="toggle-menu">menu <span className="drop-icon">▾</span></label>
                                <input type="checkbox" id="tm" />
                                <ul className="main-menu clearfix d-inline-flex">
                                    <li onClick={() => { this.props.history.push("/dashboard") }}><a>Dashboard</a></li>
                                    {!!this.state.user_role && this.state.user_role === "Admin" &&
                                        <li onClick={() => { this.props.history.push("/affiliateRequest") }}><a>Affiliate Request</a></li>
                                    }
                                    <li onClick={() => { this.props.history.push("/affiliateList") }}><a>Affiliate List</a></li>
                                    <li onClick={() => { this.props.history.push("/affiliateClientList") }}><a>Client List</a></li>
                                        <li onClick={() => { this.props.history.push("/affiliateReport") }}><a>Affiliate Report</a></li>
                                        <li onClick={() => { this.props.history.push("/affiliateClientReport") }}><a>Client Report</a></li>
                                    {/* {!!this.state.user_role && this.state.user_role === "Admin" &&
                                    } */}
                                    {/* <li onClick={() => { this.props.history.push("/clients") }}><a>Client List</a></li> */}
                                    {/* <li>
                                        <a href="#">Reports<span className="drop-icon">▾</span>
                                            <label title="Toggle Drop-down" className="drop-icon" htmlFor="sm1">▾</label>
                                        </a>
                                        <input type="checkbox" id="sm1" />
                                        <ul className="sub-menu">
                                            <li><a onClick={() => { this.props.history.push("/userdetail") }}>User Details</a></li>
                                            <li><a onClick={() => { this.props.history.push("/usersettlement") }}>Affiliate Details</a></li>
                                            <li><a onClick={() => { this.props.history.push("/profitloss") }}>Profit & Loss Report</a></li>
                                        </ul>
                                    </li> */}
                                    <li onClick={() => { this.props.history.push("/changepassword") }}><a>Change Password</a></li>
                                    {!!this.state.user_role && this.state.user_role === "Admin" &&
                                    <li className=""><a onClick={() => { this.props.history.push("/activitylogs") }}>Activity Logs</a></li>
                                }
                                </ul>
                            </nav>
                        </div>
                        <div className="w3-sidebar w3-bar-block w3-border-right" style={{ display: "none" }} id="mySidebar">
                            <ul>
                                <li className=""><a onClick={() => { this.props.history.push("/dashboard") }}><img alt="" src={BASE_IMAGE_PATH + "/aimg/Clients.svg"} className="ball-images-tab" />Dashboard</a></li>
                                {!!this.state.user_role && this.state.user_role === "Admin" &&
                                    <li className=""><a onClick={() => { this.props.history.push("/affiliateRequest") }}><img alt="" src={BASE_IMAGE_PATH + "/aimg/Clients.svg"} className="ball-images-tab" />Affiliate Request</a></li>
                                }
                                <li className=""><a onClick={() => { this.props.history.push("/affiliateList") }}><img alt="" src={BASE_IMAGE_PATH + "/aimg/Clients.svg"} className="ball-images-tab" />Affiliate List</a></li>
                                <li className=""><a onClick={() => { this.props.history.push("/affiliateClientList") }}><img alt="" src={BASE_IMAGE_PATH + "/aimg/Clients.svg"} className="ball-images-tab" />Client List</a></li>
                                    <li className=""><a onClick={() => { this.props.history.push("/affiliateReport") }}><img alt="" src={BASE_IMAGE_PATH + "/aimg/Clients.svg"} className="ball-images-tab" />Affiliate Report</a></li>
                                    <li className=""><a onClick={() => { this.props.history.push("/affiliateClientReport") }}><img alt="" src={BASE_IMAGE_PATH + "/aimg/Clients.svg"} className="ball-images-tab" />Client Report</a></li>
                                {/* {!!this.state.user_role && this.state.user_role === "Admin" && 
                                } */}
                                {/* <li className=""><a onClick={() => { this.props.history.push("/clients") }}><img alt="" src={BASE_IMAGE_PATH + "/aimg/Clients.svg"} className="ball-images-tab" />Client List</a></li> */}
                                {/* <li className="">
                                    <a onClick={(e) => { this.homeSubmenu('3') }} data-toggle="collapse" aria-expanded="true" className="dropdown-toggle"><img alt="" src={BASE_IMAGE_PATH + "/aimg/Settlement.svg"} className="ball-images-tab" /> Reports</a>
                                    <ul className="list-unstyled collapse" id="home3Submenu" style={{ display: "none" }}>
                                        <li><a onClick={() => { this.props.history.push("/userdetail") }}>User Details</a></li>
                                        <li><a onClick={() => { this.props.history.push("/usersettlement") }}>Affiliate Details</a></li>
                                        <li><a onClick={() => { this.props.history.push("/profitloss") }}>Profit & Loss Report</a></li>
                                    </ul>
                                </li> */}
                                <li className=""><a onClick={() => { this.props.history.push("/changepassword") }}><img alt="" src={BASE_IMAGE_PATH + "/aimg/Clients.svg"} className="ball-images-tab" />Change Password</a></li>
                                
                                {!!this.state.user_role && this.state.user_role === "Admin" &&
                                    <li className=""><a onClick={() => { this.props.history.push("/activitylogs") }}><img alt="" src={BASE_IMAGE_PATH + "/aimg/Clients.svg"} className="ball-images-tab" />Activity Logs</a></li>
                                }
                            </ul>
                        </div>
                        <div className="col-4 col-sm-5 col-md-5 col-lg-2 flot-right">

                            <div className="menu-right">
                                <ul className="right-menu">
                                    <li className="mr-0 d-inline-block">
                                        <div className="displayChatbox text-success dropdown " onClick={() => { this.setState({ showRightMenu: !this.state.showRightMenu }) }}>
                                            <span id="spnName" className="text-white d-inline dropdown-toggle pr-0" data-toggle="dropdown">{this.state.uid}</span>

                                            <div className={this.state.showRightMenu ? "dropdown-menu show" : "dropdown-menu"} style={{ marginLeft: "-25px" }}>
                                                {/* <a className="dropdown-item" onClick={() => { this.props.history.push("/changepassword") }}><i className="fa fa-long-arrow-right" aria-hidden="true"></i> Change Password</a> */}
                                                <a id="Header_lnkLogout" className="dropdown-item" onClick={() => { this.onLogout() }}> <i className="fa fa-long-arrow-right" aria-hidden="true"></i> Logout</a>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            {!!this.state.user_role && this.state.user_role === "AFFILIATE" &&
                            <div className='d-inline-block mr-2 pull-right'>
                                <div className='text-center kyc-f-icon mt-2_5'><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
                                    <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                                </svg></div>
                                {/* <div className='kyc-f kyc-color-red'>KYC</div>
                                <div className='kyc-f kyc-color-green d-none'>KYC</div> */}
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </header>
            {/* <UserDetailHeader isMktAnalysis={!!this.props.isMktAnalysis ? true : false} uid={this.state.uid} history={this.props.history} setUserAccData={(userAccData) => { this.setUserAccData(userAccData) }} setShowClubGames={() => this.setShowClubGames()} /> */}
        </>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Header);